import gsap from 'gsap';
import toggleFn from './toggle';

window.addEventListener('DOMContentLoaded', () => {
  validateInputs();
});

const forms = document.querySelectorAll('#contactForm, #newsletterForm, #newsletterForm_page, #newsletterOptin');

[...forms].map(form => {
  form?.addEventListener('submit', e => {
    e.preventDefault();
    e.stopPropagation();

    // Different endpoints if contactForm or newsletterForm
    const endpoint = form.dataset.endpoint;

    // If already clicked on submit button -> return false (stop everything)
    if (e.target.classList.contains('form--sending')) {
      return false;
    }

    e.target.classList.add('form--sending');

    const inputs = form.querySelectorAll('input,textarea,select');


    // Setting form data
    const contactData = new FormData(form);

    // Filling form data
    Object.values(inputs).map(item => {
      if (item.getAttribute('type') === 'checkbox') { // Handling checkbox inputs
        const values = document.querySelectorAll(
          `input[name="${item.getAttribute('name')}"]:checked`);
        const valuesArray = [];
        Object.values(values).
          map(item => valuesArray.push(item.id.replace(`${item.getAttribute('name')}-`, '')));

        contactData[item.getAttribute('name')] = valuesArray;
      }
      else if (item.getAttribute('type') === 'radio') { // Handling radio inputs
        if (item.checked) {
          contactData[item.getAttribute('name')] = document.querySelector(`input[name="${item.getAttribute('name')}"]:checked`).id;
        }
      }
      else { // Other inputs
        contactData[item.getAttribute('name')] = item.value;
      }
    });

    // On submit, if detecting an error : focus problematic input
    const errorInputs = document.querySelectorAll('.input--error');

    if (Object.values(errorInputs).length > 0) {
      errorInputs[0].focus();
      window.scrollTo(0, errorInputs[0].getBoundingClientRect().top + document.documentElement.scrollTop);

      e.target.classList.remove('form--sending');
      return;
    }

    // Send email
    fetch('/wp-json/' + endpoint, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    }).then(resp => resp.text()).then(async resp => {
      const contactMessage = form.querySelector('.contact--message');
      let final_message = null;

      if (resp !== 'error') { // If no error
        // Deleting inputs value
        const inputToFlush = form.querySelectorAll('input:not(#pardot_extra_field,#pardot_extra_field_nl,#form_language,#guid,#optin_yes,#optin_no,[hidden]),textarea,select');

        Object.values(inputToFlush).map(input => {
          input.value = '';
          input.checked = false;
          input.classList.remove('edited');
        });

        final_message = form.dataset.messageValidation || `Merci pour votre message. <br/> Nous vous recontacterons dans les plus brefs délais.`;

        // reset form status to default
      } else {
        final_message = form.dataset.messageError || `Le message n'a pas pu être envoyé. Veuillez réessayer ulterieurement. Merci.`;
      }


      // Setting and showing validation message
      if (contactMessage) {
        contactMessage.innerHTML = final_message
      }

      e.target.classList.remove('form--sending');

    });
  });
});

//Disable enter for messages
const textArea = document.querySelectorAll('textarea');
Object.values(textArea).map(el =>
  el.addEventListener('keydown', e => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
  }),
);

// Check input with patterns
const validateInputs = () => {
  const inputs = document.querySelectorAll('input[data-pattern]');

  Object.values(inputs).map(input => {
    const pattern = input.dataset.pattern;
    const regexp = new RegExp(pattern, 'g');
    input.setAttribute('aria-describedby', input.name + "_err_msg");
    // creating error message SPAN element
    const error_message = document.createElement('P');
    error_message.classList.add('error--message');
    error_message.id = input.name + "_err_msg";
    error_message.innerText = input.dataset.error;

    // Each time the user blurs a input with a data-pattern attribute
    input.addEventListener('blur', () => {
      if (input.value !== '') { // check if value is not empty
        input.classList.toggle('input--error', !input.value.match(regexp)); // add class if input value doesn't match regexp in [data-pattern]

        if (!input.value.match(regexp)) { // adding error message
          input.closest('div').appendChild(error_message);
        }
        else { // remove if value is ok
          error_message.remove();
          input.removeAttribute('aria-describedby')
        }
      }
      else { // If empty no need for error state (classname + error-message span)
        input.classList.remove('input--error');
        error_message.remove();
        input.removeAttribute('aria-describedby')
      }
    });

    // When typing on input we do the same checking process and remove the error status
    input.addEventListener('keyup', () => {
      if (input.value.match(regexp) || input.value === '') {
        input.classList.remove('input--error');
        error_message.remove();
      }
    });
  });

  // Setting edited status to input (for label position on focus)
  Object.values(document.querySelectorAll('form input, form select, form textarea')).map(item => {
    const events = ['blur', 'keyup'];

    events.map(event => {
      item.addEventListener(event, () => {
        if (item.value === '') {
          item.classList.remove('edited');
        }
        else {
          item.classList.add('edited');
        }
      });
    });
  });
};
